export default __webpack_public_path__ + "static/media/appoint_thumb.60fa0833.png";